import { PathElementTypes } from '../../../architecture/interfaces/IPathElement';
import { PathElement } from './PathElement';

export class PropertyElement extends PathElement {
  type = PathElementTypes.PropertyElement;
  constructor(public key: string) {
    super(key);
  }
}
